import React from "react";

import "./Footer.css";

export default function Footer() {
  return (
    <p className="open-source">
      <a
        href="https://github.com/JulesC7/weather-app-in-react"
        target="_blank"
        className="link"
        rel="noreferrer"
      >
        Open source code
      </a>
      , by Julia Chybelis
    </p>
  );
}
